'use es6';

import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { contains, findWhere, isObject, isString, omit } from 'underscore';
import I18n from 'I18n';
import EmailAddressPattern from 'PatternValidationJS/patterns/EmailAddress';
import PortalIdParser from 'PortalIdParser';
import ModuleCompatibilityTagTypes from 'marketplace-lib/constants/ModuleCompatibilityTagTypes';
import ModulePurposeOptions from '../constants/CustomModulePurposeOptions';
import EmailCodingTypeOptions from '../constants/EmailCodingTypeOptions';
import FeatureOptions from '../constants/FeatureOptions';
import GoodFiltersAndPage from '../constants/GoodFiltersAndPage';
import GoodsPriceOptions from '../constants/GoodsPriceOptions';
import GoodSubTypeGroups from '../constants/GoodSubTypeGroups';
import GoodSubTypes from '../constants/GoodSubTypes';
import InitialFilterParams from '../constants/InitialFilterParams';
import NumericFilterParams from '../constants/NumericFilterParams';
import SystemPageSubTypes from '../constants/SystemPageSubTypes';
import RequestStatusTypes from '../constants/RequestStatusTypes';
import ButtonStates from '../constants/ButtonStates';
import { MINIMUM_REVIEWS_REQUIRED_TO_DISPLAY } from '../constants/ReviewListParams';
import { isProd } from '../utils/env';
import { isMainCategory } from './sidebarUtils';
export function isValidEmailAddress(email) {
  return EmailAddressPattern.test(email);
}
export function getParentBlogUrlPath(asset) {
  return "/blog?selected=" + asset.getIn(['model', 'parentBlog', 'id']);
}
export function replaceAllProductsCategoryName(categoryName) {
  if (categoryName === 'all products') {
    return I18n.text('goodsZeroState.categoryNameForAllProducts');
  }

  return categoryName;
}
export function getAppBaseUrl() {
  return "https://app.hubspot" + (isProd() ? '' : 'qa') + ".com";
}

function getShortLinkToMarketplace() {
  return getAppBaseUrl() + "/l/marketplace";
}

export function getRedirectToPurchases() {
  return getShortLinkToMarketplace() + "/manage-purchases";
}
export function getRedirectToDetails(providerUrlToken, goodNameUrlToken) {
  return getShortLinkToMarketplace() + "/products/" + providerUrlToken + "/" + goodNameUrlToken;
}
export function isCustomer(portal) {
  return isObject(portal) && !!portal.portal_id;
}
export function isTrialPortal(portal) {
  return isObject(portal) && !!portal.trial;
}
export function redirectToPublicFacingDirectory() {
  window.location = 'http://marketplace.hubspot.com/products';
}
export function resetFilters(filterTypes, newGoodFiltersAndPage) {
  filterTypes.forEach(function (filterType) {
    newGoodFiltersAndPage[filterType] = InitialFilterParams.get(filterType);
  });
  return newGoodFiltersAndPage;
}
export function resetNotApplicableFilters(currentGoodFiltersAndPage, newGoodFiltersAndPage) {
  if (newGoodFiltersAndPage.subType) {
    if (currentGoodFiltersAndPage.get('subType') === GoodSubTypes.EMAIL_TEMPLATES) {
      newGoodFiltersAndPage = resetFilters([GoodFiltersAndPage.CODING_TYPE], newGoodFiltersAndPage);
    } else if (currentGoodFiltersAndPage.get('subType') === GoodSubTypes.PACKS) {
      newGoodFiltersAndPage = resetFilters([GoodFiltersAndPage.CHILD_TYPES], newGoodFiltersAndPage);
    } else if (currentGoodFiltersAndPage.get('subType') === GoodSubTypes.CUSTOM_MODULE) {
      newGoodFiltersAndPage = resetFilters([GoodFiltersAndPage.MODULE_PURPOSE], newGoodFiltersAndPage);
      newGoodFiltersAndPage = resetFilters([GoodFiltersAndPage.MODULE_COMPATIBILITY], newGoodFiltersAndPage);
    }

    if (newGoodFiltersAndPage.subType === GoodSubTypes.PACKS || newGoodFiltersAndPage.subType === GoodSubTypes.CUSTOM_MODULE || newGoodFiltersAndPage.subType === GoodSubTypes.CMS_THEME) {
      return resetFilters([GoodFiltersAndPage.FEATURES, GoodFiltersAndPage.PAGE_LAYOUT, GoodFiltersAndPage.TEMPLATE_PURPOSE], newGoodFiltersAndPage);
    }
  }

  return newGoodFiltersAndPage;
}
export function isCustomModule(goodDetails) {
  return goodDetails.get('subType') === GoodSubTypes.CUSTOM_MODULE;
}
export function isTheme(goodDetails) {
  return goodDetails.get('subType') === GoodSubTypes.CMS_THEME;
}
export function isEmailTemplate(goodDetails) {
  return goodDetails.get('subType') === GoodSubTypes.EMAIL_TEMPLATES;
}
export function isSystemPage(subType) {
  return !!SystemPageSubTypes[subType];
}
export function getPathToDirectoryFilteredBySubType(goodSubType) {
  return "/products?subType=" + goodSubType;
}
export function getArrOfTextValPairsForSelect(optionsArr, textLookupFunc) {
  return optionsArr.map(function (option) {
    return {
      text: textLookupFunc(option),
      value: option
    };
  });
}
export function getAlphaSortedArrOfTextValPairsForSelect(optionsArr, textLookupFunc) {
  var firstItem = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var arrOfTextValPairs = getArrOfTextValPairsForSelect(optionsArr, textLookupFunc);
  var sortedArrOfTextValPairs = arrOfTextValPairs.sort(function (opt1, opt2) {
    return opt1.text.localeCompare(opt2.text);
  });

  if (firstItem) {
    sortedArrOfTextValPairs.unshift({
      text: textLookupFunc(firstItem),
      value: firstItem
    });
  }

  return sortedArrOfTextValPairs;
}
export function hasCertificationBadge(providerCertsJsArr, certType) {
  return contains(providerCertsJsArr, certType);
}
export function getMultiselectCheckboxFilterOptions(filterType) {
  if (filterType === GoodFiltersAndPage.PRICE) {
    return [GoodsPriceOptions.FREE, GoodsPriceOptions.PAID];
  } else if (filterType === GoodFiltersAndPage.CODING_TYPE) {
    return [EmailCodingTypeOptions.DRAG_AND_DROP, EmailCodingTypeOptions.CODED_FILE];
  } else if (filterType === GoodFiltersAndPage.CHILD_TYPES) {
    return [GoodSubTypes.EMAIL_TEMPLATES, GoodSubTypes.LANDING_PAGES, GoodSubTypes.SITE_PAGES, GoodSubTypes.BLOG_TEMPLATES, GoodSubTypeGroups.SYSTEM_PAGE_TEMPLATES].filter(Boolean);
  } else if (filterType === GoodFiltersAndPage.MODULE_COMPATIBILITY) {
    return [ModuleCompatibilityTagTypes.COMPATIBLE_BLOG, ModuleCompatibilityTagTypes.COMPATIBLE_EMAIL, ModuleCompatibilityTagTypes.COMPATIBLE_PAGE];
  }

  return [];
}
export function isTemplatePack(goodOrGoodDetails) {
  return goodOrGoodDetails.get('subType') === GoodSubTypes.PACKS;
}

function isNonInitialValue(updatedGoodFilters, filterType) {
  return updatedGoodFilters.get(filterType) !== InitialFilterParams.get(filterType);
}

export function getQueryParamsForSingleselectFilters(singleSelectFilterTypes, updatedGoodFilters) {
  return singleSelectFilterTypes.filter(function (filterType) {
    return isNonInitialValue(updatedGoodFilters, filterType);
  }).map(function (filterType) {
    return _defineProperty({}, filterType, updatedGoodFilters.get(filterType));
  });
}
export function addQueryParamsForMultiselectFilters(queryParams, multiSelectFilterTypes, updatedGoodFilters) {
  multiSelectFilterTypes.forEach(function (filterType) {
    if (isNonInitialValue(updatedGoodFilters, filterType)) {
      queryParams.push(_defineProperty({}, filterType, updatedGoodFilters.get(filterType).toJS()));
    }
  });
  return queryParams;
}
export function addQueryParamForPage(queryParams, updatedGoodFilters, addOneToAdjustForZeroIndexing) {
  if (isNonInitialValue(updatedGoodFilters, GoodFiltersAndPage.PAGE)) {
    queryParams.push(_defineProperty({}, GoodFiltersAndPage.PAGE, addOneToAdjustForZeroIndexing ? updatedGoodFilters.get(GoodFiltersAndPage.PAGE) + 1 : updatedGoodFilters.get(GoodFiltersAndPage.PAGE)));
  }

  return queryParams;
}
export function getQueryParams(updatedGoodFilters) {
  var singleSelectFilterTypes = [GoodFiltersAndPage.SEARCH_TERM, GoodFiltersAndPage.PROVIDER, GoodFiltersAndPage.SUB_TYPE, GoodFiltersAndPage.SORT_BY, GoodFiltersAndPage.INDUSTRY, GoodFiltersAndPage.PAGE_LAYOUT, GoodFiltersAndPage.TEMPLATE_PURPOSE, GoodFiltersAndPage.LIMIT];
  var multiSelectFilterTypes = [GoodFiltersAndPage.PRICE, GoodFiltersAndPage.CODING_TYPE, GoodFiltersAndPage.FEATURES, GoodFiltersAndPage.CHILD_TYPES, GoodFiltersAndPage.MODULE_COMPATIBILITY, GoodFiltersAndPage.MODULE_PURPOSE];
  var queryParams = getQueryParamsForSingleselectFilters(singleSelectFilterTypes, updatedGoodFilters);
  queryParams = addQueryParamsForMultiselectFilters(queryParams, multiSelectFilterTypes, updatedGoodFilters);
  queryParams = addQueryParamForPage(queryParams, updatedGoodFilters, true);
  return queryParams;
}
export function getUrlWithNonInitialFiltersAndPageShown(updatedGoodFilters) {
  return {
    pathname: '/products',
    query: Object.assign.apply(Object, [{}].concat(_toConsumableArray(getQueryParams(updatedGoodFilters))))
  };
}

function parseNumericParam(queryParams, paramType) {
  if (!queryParams[paramType] || !InitialFilterParams.has(paramType)) {
    return queryParams;
  }

  var parsedParamValue = parseInt(queryParams[paramType], 10);
  var parsedIntOrInitialValue = isNaN(parsedParamValue) ? InitialFilterParams.get(paramType) : parsedParamValue;
  return Object.assign({}, queryParams, _defineProperty({}, paramType, parsedIntOrInitialValue));
}

function parseNumericParams(queryParams, paramTypes) {
  return paramTypes.reduce(parseNumericParam, queryParams);
}

function adjustPageToZeroIndex(queryParams) {
  var pageQueryParam = queryParams[GoodFiltersAndPage.PAGE];

  if (pageQueryParam > 0) {
    return Object.assign({}, queryParams, _defineProperty({}, GoodFiltersAndPage.PAGE, pageQueryParam - 1));
  }

  return queryParams;
}

export function getQueryParamsWithParsedInt(queryParams) {
  return adjustPageToZeroIndex(parseNumericParams(queryParams, NumericFilterParams));
}
export function isOnlyOneMultiSelectFilterOptionSelected(filterOptionParams) {
  return isString(filterOptionParams);
}
export function parseQueryParamsForMultiselectFilters(queryParams) {
  var multiSelectFilterTypes = [GoodFiltersAndPage.PRICE, GoodFiltersAndPage.CODING_TYPE, GoodFiltersAndPage.FEATURES, GoodFiltersAndPage.CHILD_TYPES, GoodFiltersAndPage.MODULE_COMPATIBILITY, GoodFiltersAndPage.MODULE_PURPOSE];
  multiSelectFilterTypes.forEach(function (filterType) {
    if (isOnlyOneMultiSelectFilterOptionSelected(queryParams[filterType])) {
      queryParams[filterType] = [queryParams[filterType]];
    }
  });
  return queryParams;
}
export function mergeGoodFiltersAndPage(existingGoodFiltersAndPage, newGoodFiltersAndPage) {
  return existingGoodFiltersAndPage.merge(newGoodFiltersAndPage);
}

function getEnglishTextFieldFromArrOfMultiLangObjects(arr) {
  if (arr) {
    var enLangObj = findWhere(arr, {
      language: 'EN'
    });

    if (enLangObj) {
      return enLangObj.text;
    }

    return '';
  }

  return '';
}

export function getEnglishTextFieldFromGoodTextObj(field, goodTextObj) {
  return getEnglishTextFieldFromArrOfMultiLangObjects(goodTextObj[field]);
}
export function getEnglishTextFieldFromTextsMap(field, textsMap) {
  return getEnglishTextFieldFromArrOfMultiLangObjects(textsMap.get(field).toJS());
}
export function areAllSidebarFiltersAtInitialValue(goodFilters) {
  return isMainCategory(goodFilters.get(GoodFiltersAndPage.SUB_TYPE)) && goodFilters.get(GoodFiltersAndPage.PRICE).equals(InitialFilterParams.get(GoodFiltersAndPage.PRICE)) && goodFilters.get(GoodFiltersAndPage.INDUSTRY) === InitialFilterParams.get(GoodFiltersAndPage.INDUSTRY) && goodFilters.get(GoodFiltersAndPage.CHILD_TYPES).equals(InitialFilterParams.get(GoodFiltersAndPage.CHILD_TYPES)) && goodFilters.get(GoodFiltersAndPage.FEATURES).equals(InitialFilterParams.get(GoodFiltersAndPage.FEATURES)) && goodFilters.get(GoodFiltersAndPage.PAGE_LAYOUT) === InitialFilterParams.get(GoodFiltersAndPage.PAGE_LAYOUT) && goodFilters.get(GoodFiltersAndPage.TEMPLATE_PURPOSE) === InitialFilterParams.get(GoodFiltersAndPage.TEMPLATE_PURPOSE) && goodFilters.get(GoodFiltersAndPage.CODING_TYPE).equals(InitialFilterParams.get(GoodFiltersAndPage.CODING_TYPE)) && goodFilters.get(GoodFiltersAndPage.PROVIDER) === InitialFilterParams.get(GoodFiltersAndPage.PROVIDER) && goodFilters.get(GoodFiltersAndPage.MODULE_PURPOSE).equals(InitialFilterParams.get(GoodFiltersAndPage.MODULE_PURPOSE)) && goodFilters.get(GoodFiltersAndPage.MODULE_COMPATIBILITY).equals(InitialFilterParams.get(GoodFiltersAndPage.MODULE_COMPATIBILITY));
}
export function getSubTypesFromPackCounts(packCounts) {
  return packCounts.map(function (packCount) {
    return packCount.get('subType');
  }).toArray();
}
export function getSubTypesBelongingToGroup(subTypeGroup) {
  var systemPages = Object.keys(SystemPageSubTypes);
  var pages = [GoodSubTypes.LANDING_PAGES, GoodSubTypes.SITE_PAGES].concat(_toConsumableArray(systemPages));

  switch (subTypeGroup) {
    case GoodSubTypeGroups.SYSTEM_PAGE_TEMPLATES:
      return systemPages;
    // TODO deprecated

    case GoodSubTypeGroups.PAGE_TEMPLATES:
      return pages;

    case GoodSubTypeGroups.TEMPLATES:
      return [GoodSubTypes.EMAIL_TEMPLATES, GoodSubTypes.BLOG_TEMPLATES, GoodSubTypes.LANDING_PAGES, GoodSubTypes.SITE_PAGES].concat(_toConsumableArray(systemPages));

    default:
      return [];
  }
}
export function getClearedSidebarFilters() {
  var _ref2;

  var mainCategory = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : GoodSubTypes.ALL;
  return _ref2 = {}, _defineProperty(_ref2, GoodFiltersAndPage.SUB_TYPE, mainCategory), _defineProperty(_ref2, GoodFiltersAndPage.PRICE, InitialFilterParams.get(GoodFiltersAndPage.PRICE)), _defineProperty(_ref2, GoodFiltersAndPage.CODING_TYPE, InitialFilterParams.get(GoodFiltersAndPage.CODING_TYPE)), _defineProperty(_ref2, GoodFiltersAndPage.INDUSTRY, InitialFilterParams.get(GoodFiltersAndPage.INDUSTRY)), _defineProperty(_ref2, GoodFiltersAndPage.CHILD_TYPES, InitialFilterParams.get(GoodFiltersAndPage.CHILD_TYPES)), _defineProperty(_ref2, GoodFiltersAndPage.FEATURES, InitialFilterParams.get(GoodFiltersAndPage.FEATURES)), _defineProperty(_ref2, GoodFiltersAndPage.PAGE_LAYOUT, InitialFilterParams.get(GoodFiltersAndPage.PAGE_LAYOUT)), _defineProperty(_ref2, GoodFiltersAndPage.TEMPLATE_PURPOSE, InitialFilterParams.get(GoodFiltersAndPage.TEMPLATE_PURPOSE)), _defineProperty(_ref2, GoodFiltersAndPage.MODULE_PURPOSE, InitialFilterParams.get(GoodFiltersAndPage.MODULE_PURPOSE)), _defineProperty(_ref2, GoodFiltersAndPage.MODULE_COMPATIBILITY, InitialFilterParams.get(GoodFiltersAndPage.MODULE_COMPATIBILITY)), _defineProperty(_ref2, GoodFiltersAndPage.PROVIDER, InitialFilterParams.get(GoodFiltersAndPage.PROVIDER)), _ref2;
}
export function getPollIntervalInSeconds(elapsedSeconds) {
  if (elapsedSeconds < 2 * 60) {
    return 2;
  } else if (elapsedSeconds < 10 * 60) {
    return 10;
  }

  return 3 * 60;
}
export function getPollIntervalInMilliseconds(elapsedSeconds) {
  return getPollIntervalInSeconds(elapsedSeconds) * 1000;
}
export function getSecondsElapsedBeforeNextPolling(elapsedSeconds) {
  return elapsedSeconds + getPollIntervalInSeconds(elapsedSeconds);
}
export function hasFifteenMinutesElapsed(elapsedSeconds) {
  return elapsedSeconds === 15 * 60;
}
export function getButtonState(requestStatus) {
  switch (requestStatus) {
    case RequestStatusTypes.UNINITIALIZED:
    case RequestStatusTypes.FAILED:
      return ButtonStates.INITIAL;

    case RequestStatusTypes.PENDING:
      return ButtonStates.SAVING;

    default:
      return ButtonStates.INITIAL;
  }
}
export function getBaseUrlForCustomers() {
  return "/marketplace/" + PortalIdParser.get();
}
export function isBelowMinimumRequiredReviews(reviewCount) {
  return reviewCount < MINIMUM_REVIEWS_REQUIRED_TO_DISPLAY;
}
export function getUnselectedOptions(optionsObj, selectedFiltersList) {
  return Object.keys(omit(optionsObj, selectedFiltersList.toJS()));
}
export function getMultiselectDropdownOptions(filterType) {
  if (filterType === GoodFiltersAndPage.FEATURES) {
    return omit(FeatureOptions, FeatureOptions.NONE);
  } else if (filterType === GoodFiltersAndPage.MODULE_PURPOSE) {
    return omit(ModulePurposeOptions, ModulePurposeOptions.NONE);
  }

  return {};
}
export function getMultiselectDropdownClass(filterType) {
  if (filterType === GoodFiltersAndPage.FEATURES) {
    return 'integrate-feature-dropdown';
  } else if (filterType === GoodFiltersAndPage.MODULE_PURPOSE) {
    return 'integrate-module-purpose-dropdown';
  }

  return '';
}
export function getMultiselectFilterObjAfterRemove(filterType, selectedFilters, filterToRemove) {
  return _defineProperty({}, filterType, selectedFilters.filter(function (filter) {
    return filter !== filterToRemove;
  }));
}
export function getPurchaseButtonClassNames(previewMode) {
  return "purchase-button integrate-purchase-button" + (previewMode ? " preview-mode" : "");
}
export function getUrlWithProviderFilter(providerName) {
  return getUrlWithNonInitialFiltersAndPageShown(InitialFilterParams.merge(_defineProperty({}, GoodFiltersAndPage.PROVIDER, providerName)));
}